<script>
export default {
  name: 'BaseBanner',
  props: {
    text: {
      type: String,
      default: ''
    },
    textColour: {
      type: String,
      default: 'white'
    },
    colour: {
      type: String,
      default: 'purple'
    },
    type: {
      type: String,
      default: 'discount',
      validator: value => {
        return ['discount', 'alert', 'standard'].includes(value)
      }
    },
    closeable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bannerClasses() {
      return `base-banner--${this.colour} base-banner--${this.type}`
    }
  },
  methods: {
    closeBanner() {
      this.$emit('closeBanner', this.type)
    },
    bannerClicked() {
      this.$emit('bannerClicked')
    }
  }
}
</script>

<template lang="pug">
.base-banner(:class='bannerClasses')
  svg.base-banner__close-icon(
    v-if='closeable'
    @click='closeBanner'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  )
    path(
      d='M12 9.887L2.55.437C1.968-.145 1.02-.145.44.438c-.584.584-.584 1.53 0 2.114L9.888 12l-9.45 9.45c-.584.583-.584 1.53 0 2.112.583.584 1.53.584 2.113 0l9.45-9.45 9.45 9.45c.583.584 1.53.584 2.112 0 .584-.583.584-1.53 0-2.113L14.112 12l9.45-9.45c.584-.583.584-1.53 0-2.112-.583-.584-1.53-.584-2.113 0L12 9.888z'
      fill='#ffffff'
      fill-rule='evenodd'
    )
  .tw-w-full.tw-text-center
    p.base-banner__text.fw--regular(
      :class='`text--${textColour}`'
      v-html='text'
      @click='bannerClicked'
    )
</template>

<style lang="stylus">
@import '../../assets/styles/modules/*'

.base-banner
  min-height: 40px
  width: 100%
  max-width: 1680px
  z-index: 2
  padding: 10px
  position: sticky

  &--discount,
  &--alert
    padding: 30px 20px

  +media-breakpoint-up(md)
    padding: 10px 20px

  &--standard
    padding: 10px 20px

  for colour in THRIVA.colours
    &--{colour}
      background: THRIVA.colours[colour]

  &__text
    max-width: 100%
    text-align: center

    a
      text-decoration: underline
      color: inherit

  +media-breakpoint-up(md)
    top: 62px

  &__close-icon
    position: absolute
    cursor: pointer
    top: 15px
    right: 10px
    width: 15px
    height: 15px
</style>
